// /accounts szegmens layout-ja — csak auth-guard + <Outlet/>. A tényleges oldalak a gyerek-route-okban:
// accounts.index (lista) · accounts.$id (read-only detail; a szerkesztő a write-fázisban jön). A LAYOUT kell,
// hogy a /accounts/$id gyerek-route rendereljen — a lista-route (accounts.index) nem tartalmaz <Outlet/>-et,
// ezért korábban a /accounts/$id-re navigálva az URL változott, de a detail nem jelent meg (a szülő a listát
// renderelte). A clients-szegmens ugyanezt a mintát követi (clients.tsx = layout, clients.index = lista).
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/accounts')({
  beforeLoad: () => requireAuth(),
  component: AccountsLayout,
});

function AccountsLayout(): JSX.Element {
  return <Outlet />;
}
